import React, { CSSProperties } from 'react'
import { Form, Select, SelectProps } from 'antd'
import { BaseInputProps } from '../../types/types'

export type InputSelectProps = {
  layout?: 'column' | 'row'
  required?: boolean
  type?: string
  errorMessage?: string
  options: any[]
  style?: CSSProperties
  formItemstyle?: CSSProperties
  mode?: 'tags' | 'multiple'
  tooltip?: string
  showSearch?: boolean
  defaultValue?: SelectProps['defaultValue']
  isLoading?: boolean
} & BaseInputProps

function InputSelect({
  value,
  label,
  disabled,
  onChange,
  layout,
  required,
  type,
  errorMessage,
  placeholder,
  options,
  style,
  formItemstyle,
  mode,
  tooltip,
  showSearch,
  className,
  defaultValue,
  ...props
}: InputSelectProps) {
  return (
    <Form.Item
      className={className}
      name={type}
      label={label}
      required={required}
      rules={[
        {
          required,
          ...(errorMessage && { message: errorMessage }),
        },
      ]}
      labelCol={layout === 'column' ? { span: 24 } : {}}
      wrapperCol={layout === 'column' ? { span: 24 } : {}}
      style={formItemstyle}
      tooltip={tooltip}
      initialValue={defaultValue}
    >
      <Select
        defaultValue={defaultValue}
        showSearch={showSearch}
        {...props}
        value={value}
        mode={mode}
        style={{ ...style, width: '100%' }}
        onChange={onChange}
        options={options || []}
        disabled={disabled}
        placeholder={placeholder}
        optionFilterProp="label"
      />
    </Form.Item>
  )
}

export default InputSelect
